import {
  useOfferImageControllerCreate,
  type CreateOfferImageDto,
} from '@konsolenkost-de/acquisition_store_server_sdk_vue';
import { toValue, type MaybeRefOrGetter } from 'vue';
import { useLoading } from '../../stores/loadingStore';

/**
 * Registering an uploaded image with an offer. Split out of `useOffer` so
 * components that only render/add images (and already receive the offer from
 * their parent) don't have to spin up the full offer context, while `useOffer`
 * still exposes it to everything holding a basket.
 */
export const useOfferImages = (offerId: MaybeRefOrGetter<number>) => {
  const { watchLoading } = useLoading();

  const { mutateAsync: createOfferImageMutate, isPending: createOfferImageLoading } =
    useOfferImageControllerCreate();

  const createOfferImage = (data: CreateOfferImageDto, withOfferId?: number) =>
    createOfferImageMutate({ offerId: withOfferId ?? toValue(offerId), data });

  const createOfferImages = (images: CreateOfferImageDto[], withOfferId?: number) =>
    Promise.all(images.map((image) => createOfferImage(image, withOfferId)));

  watchLoading(createOfferImageLoading);

  return { createOfferImage, createOfferImages, createOfferImageLoading };
};
